import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { authActions } from 'modules/auth/index'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { PASSWORD_PATH, REGISTER_PATH } from 'config'
import AuthAlerts from 'components/auth/auth-alerts'


export class SignIn extends Component {
  static propTypes = {
    signInWithEmailPassword: PropTypes.func.isRequired
  }

  constructor(props, context) {
    super(props, context)

    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit(event) {
    event.preventDefault()
    this.props.signInWithEmailPassword(this.emailInput.value, this.passwordInput.value)
  }

  render() {
    return (
      <div className="center-block auth-form__container auth-form__container--sign-in">
        <div className="auth-form">
          <AuthAlerts />
          <div className="card card-block mb-3">
            <form role="form" onSubmit={this.onSubmit} noValidate>
              <h2>Sign in</h2>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="Email"
                  name="email"
                  type="email"
                  ref={c => this.emailInput = c}
                />
              </div>
              <div className="form-group">
                <input
                  className="form-control"
                  placeholder="Password"
                  name="password"
                  type="password"
                  ref={c => this.passwordInput = c}
                />
              </div>
              <button className="btn btn-primary" type="submit">Sign In</button>
              <Link to={ PASSWORD_PATH } className="btn btn-link">Forgot password?</Link>
            </form>
          </div>
          <p>Don’t have an account yet? <Link name="register-now" to={ REGISTER_PATH }>Register now!</Link></p>
        </div>
      </div>
    )
  }
}

export default connect(null, authActions)(SignIn)



// WEBPACK FOOTER //
// ./src/components/auth/sign-in/sign-in.js